<template>
    <section class="pageContents">
      <div class="pageContents-text container">
        Iletisim
      </div>
    </section>
</template>
